/**
 * User mixins
 * @namespace UserMixins
 */

/* Helpers */
import API from "@/helpers/fetch";

export const UserMixins = {
    computed : {
        /* Logged in user */
        user : {
            get() {
                return this.$store.state.user;
            },
            set(user) {
                this.$store.commit('updateUser', user);
            }
        }
    },
    methods : {
        /**
         * Get user info
         * @param {Function} callback
         */
        async getUserInfo({callback = () => {}} = {}) {
            const url = `stakeapi/v1/user_info`;

            const res = await API.fetch({
                baseUrl: process.env.VUE_APP_STAKEAPIBASEURL,
                url,
                methods: "GET"
            });

            if(res) {
                this.user = res;
                callback(res);
            }
        }
    }
}